import React from 'react';
import useDocumentTitle from '../../../components/useDocumentTitle';
import HomeNFTs from '../../../components/cards/HomeNFTs';
import HeroMarketplace from '../../../components/hero/HeroMarketplace';

const AllNFTs = () => {
  useDocumentTitle(' Collections');

  return (
    <div>
      <HeroMarketplace />
      <div className="sectin ">
        <div className="conainer">
          <HomeNFTs length={12} />
        </div>
      </div>
    </div>
  );
};

export default AllNFTs;
